import { render, staticRenderFns } from "./NegeriDaerahManager.vue?vue&type=template&id=550979cb&scoped=true"
import script from "./NegeriDaerahManager.vue?vue&type=script&lang=js"
export * from "./NegeriDaerahManager.vue?vue&type=script&lang=js"
import style0 from "./NegeriDaerahManager.vue?vue&type=style&index=0&id=550979cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550979cb",
  null
  
)

export default component.exports